import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
// import Stack from '@mui/material/Stack';
import { Box, Stack } from '@mui/material';

export default function BusinessCardSkeleton() {
    return (
        <Box mt={10} alignItems={'center'} width={'70%'}>
            <Stack direction={'row'}>
                <Skeleton variant="circular" height={40} width={40} />
                <Stack direction={'column'} width={'70%'} marginLeft={'20px'}>
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                    <Skeleton variant="text" />
                </Stack>
            </Stack>
            <Stack direction={'row'} width={210} justifyContent={'space-evenly'}>
                <Skeleton variant="text" width={150} />
                <Skeleton variant="circular" width={30} height={30} />
            </Stack>
        </Box>
    );
}
